import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { Icons as GridIcons } from "Components/AppGrid/shipeezi-new-grid";
import { colors } from "@zapalacorp/tokens";
import { BiImport, BiMove } from "react-icons/bi";
import { BsBox } from "react-icons/bs";

export const StorageBoxesAndUnitsGrid = styled("div")(() => ({
  padding: "24px 32px",
  display: "flex",
  flexDirection: "row",
  "& > div": {
    width: "100%",
  },
}));

export const ViewIcon = styled(GridIcons.view)(() => ({
  cursor: "pointer",
}));

export const UnloadIcon = styled(BiImport)(() => ({
  cursor: "pointer",
}));

export const ChangeLocationIcon = styled(BiMove)(() => ({
  cursor: "pointer",
}));

export const BoxIcon = styled(BsBox)(() => ({
  height: "20px !important",
  width: "20px !important",
  color: "#308CDB",
}));

export const OrderOption = styled("span")(() => ({
  cursor: "pointer",
  display: "flex",
}));

const styles = makeStyles(() => ({
  label: {
    textAlign: "left",
  },
  labelDisabled: {
    textAlign: "left",
    color: "#667085",
  },
  p0: {
    padding: 0,
  },
  button: {
    justifyContent: "flex-start",
  },
  activityButton: {
    color: colors.brandBlue500,
    border: `1px solid ${colors.brandBlue500}`,
    "&:hover": {
      color: colors.brandBlue500,
      border: `1px solid ${colors.brandBlue500}`,
    },
    "&:focus": {
      color: colors.brandBlue500,
      border: `1px solid ${colors.brandBlue500}`,
    },
  },
  buttonDisabled: {
    justifyContent: "flex-start",
    opacity: 0.5,
    cursor: "default",
  },
}));

export default styles;
